module.exports = __webpack_public_path__ + "static/media/RUMORS_PANEL.aa113447.png";